// @flow
import * as React from 'react';

// Pages
import VerifyAccounts from './pages/VerifyAccounts';
import Plaid from './pages/Plaid';
// import MX from './pages/MX';
import Intro from './pages/Intro';
import Search from './pages/Search';
import Form from './pages/Form';
import Results from './pages/Results';
import ExitConfirm from './pages/ExitConfirm';

// Components
import LoaderOverlay from './components/LoaderOverlay';
import Container from './components/Container';

// HOCs
import withEventManager, { EVENT_TYPES } from './HOCs/withEventManager';
import withRootReducer from './HOCs/withRootReducer';
import withErrorBoundary from './HOCs/withErrorBoundary';

// Types
import type { TEventManagerProps } from './HOCs/withEventManager';
import type { TRootState, TActionCreators } from './reducers';


const routeConfig = {
  '/verify-accounts': { Component: VerifyAccounts },
  '/plaid': { Component: Plaid },
  // '/mx': { Component: MX },
  '/intro': { Component: Intro },
  '/search': { Component: Search },
  '/form': { Component: Form },
  '/results': { Component: Results },
  '/exit-confirm': { Component: ExitConfirm },
};

function App(props: TRootState & TActionCreators & TEventManagerProps): ?React.Node {
  const [animationEnabled, setAnimationEnabled] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [__, raiseError] = React.useState(null); // eslint-disable-line

  React.useEffect(() => {
    (async () => {
      if (isLoading && !animationEnabled) setAnimationEnabled(true);
      if (props.config && !props.config.initialized) {
        try {
          if (!isLoading) setIsLoading(true);
          await Promise.all([props.asyncFetchConfig(), props.asyncFetchMerchants({ name: '' })]);
          props.dispatchEvent(EVENT_TYPES.open, {});
          setIsLoading(false);
        } catch (error) {
          raiseError(() => { throw error; });
        }
      }
    })();
  }, [props, isLoading, animationEnabled]);

  const currentRoute = props.navigation ? routeConfig[props.navigation.current.path] : null;
  const Component = (currentRoute && !isLoading) ? currentRoute.Component : Container;

  return (
    <LoaderOverlay animationEnabled={animationEnabled} isLoading={isLoading}>
      <Component {...props} setIsLoading={setIsLoading} />
    </LoaderOverlay>
  );
}

// $FlowFixMe
export default withEventManager(withRootReducer(withErrorBoundary(App)));
